// extracted by mini-css-extract-plugin
export default {"drawerRoot":"bw_bx"};